<template>
    <div class="main">
      <div class="main-top">
        <div class="images"></div>
        <p class="text fwb">POCKET</p>
      </div>
      <div class="title">
        <p class="fwb">Pocket</p>
        <p>元宇宙语音社交平台</p>
      </div>

      <div class="beian">
        <div @click="cahngUrl" class="text1"> <img class="left5" src="../../assets/tx001.png" alt=""><span class="left5">川公网安备</span> <span>51019002003350号</span></div>
        <div class="lh30"><span class="left5">川网文（2022）3451-727号</span> <a class="ffff" href="https://beian.miit.gov.cn/">蜀ICP备2022020984号-1</a></div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "index",
    components: {
    },
    data() {
      return {
      };
    },
    created() {

    },
    mounted() {
  
    },
    methods: {
      cahngUrl(){
        window.location.href = "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002003350"
      }
    },
  };
  
  </script>
  
  <style>
  * {
    padding: 0;
    margin: 0;
  }
  .main {
    height: 100%;
    color: #ffff;
    background-image: url("../../assets/background.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 767px) {
    .main-top {
      display: flex;
      align-items: center;
      padding-left: 10px;
    }
  
    .images {
      width: 50px;
      height: 60px;
      background-image: url("../../assets/download/icon.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: 0px 9px;
    }
  
    .text {
      color: #ffff;
      font-size: 22px;
      margin-left: 20px;
    }
  
    .title {
      font-size: 30px;
      color: #ffff;
      margin-top: 50px;
      margin-left: 25px;
      line-height: 50px;
    }
  
    .download {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 160px;
    }
  
    .fwb {
      font-weight: bold;
    }
  }
  @media screen and (min-width: 768px) {
    .main-top {
      width: 400px;
      height: 90px;
      display: flex;
      align-items: center;
      margin-left: 60px;
      box-sizing: border-box;
  
    }
  
    .images {
      width: 70px;
      height: 90px;
      background-image: url("../../assets/download/icon.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: 0px 13px;
  
    }
  
    .text {
      color: #ffff;
      font-size: 30px;
      margin-left: 20px;
    }
  
    .title {
      font-size: 60px;
      color: #ffff;
      margin-left: 110px;
      margin-top: 200px;
      line-height: 100px;
    }
  
    .download {
      margin-left: 60px;
      margin-top: 145px;
      display: flex;
      cursor: pointer;
    }
  
    .download img {
      width: 210px;
      height: 64px;
    }
  
    .fwb {
      font-weight: bold;
    }
  
    .mr28 {
      margin-right: 28px;
    }
  
  }
  @media screen and (min-width: 992px) {
    .main-top {
      margin-left: 100px;
  
    }
    .title {
      margin-left: 275px;
    }
    .download {
      margin-left: 275px;
    }
  }
  .beian{
    width: 100%;
    position: fixed;
    bottom: 0;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .text1{
    line-height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .left5{
    margin-right: 5px;
  }
  .lh30{
    line-height: 30px; 
  }
  .ffff{
    color: #ffff;
  }
  </style>